import React, { useState } from "react";
import "./FunctionExamplesDemo.css";
import { motion } from "framer-motion";

const FunctionExamplesDemo = () => {
  // State for greet_user demo
  const [greetCount, setGreetCount] = useState(0);

  // State for greet(name) demo
  const [name, setName] = useState("");
  const [greetNameOutput, setGreetNameOutput] = useState("");

  // State for add(a, b) demo
  const [a, setA] = useState(0);
  const [b, setB] = useState(0);
  const [sumResult, setSumResult] = useState(null);

  // Handlers
  const handleGreetUser = () => {
    setGreetCount(prev => prev + 1);
  };

  const handleGreetName = () => {
    setGreetNameOutput(`Привет, ${name || 'пользователь'}!`);
  };

  const handleAdd = () => {
    setSumResult(a + b);
  };

  return (
    <div className="function-examples-demo">
      <h3>Интерактивные примеры функций</h3>

      <section className="demo-card">
        <pre>
          <code>
{`def greet_user():
    print("Привет, пользователь!")

greet_user()`}
          </code>
        </pre>
        <button onClick={handleGreetUser}>Вызвать greet_user()</button>
        <motion.div
          className="output"
          animate={{ opacity: greetCount > 0 ? 1 : 0 }}
        >
          {Array(greetCount).fill("Привет, пользователь!\n").map((line, i) => (
            <div key={i}>{line.trim()}</div>
          ))}
        </motion.div>
      </section>

      <section className="demo-card">
        <pre>
          <code>
{`def greet(name):
    print(f"Привет, {name}!")

greet("Аня")`}
          </code>
        </pre>
        <input
          type="text"
          placeholder="Введите имя"
          value={name}
          onChange={e => setName(e.target.value)}
        />
        <button onClick={handleGreetName}>Вызвать greet(name)</button>
        <motion.div
          className="output"
          initial={{ opacity: 0 }}
          animate={{ opacity: greetNameOutput ? 1 : 0 }}
        >
          {greetNameOutput}
        </motion.div>
      </section>

      <section className="demo-card">
        <pre>
          <code>
{`def add(a, b):
    return a + b

result = add(3, 5)
print(result)`}
          </code>
        </pre>
        <div className="input-pair">
          <div>
            <label>A:</label>
            <input
              type="number"
              value={a}
              onChange={e => setA(Number(e.target.value))}
            />
          </div>
          <div>
            <label>B:</label>
            <input
              type="number"
              value={b}
              onChange={e => setB(Number(e.target.value))}
            />
          </div>
        </div>
        <button onClick={handleAdd}>Вычислить add(a, b)</button>
        <motion.div
          className="output"
          initial={{ opacity: 0 }}
          animate={{ opacity: sumResult !== null ? 1 : 0 }}
        >
          {sumResult !== null && `Результат: ${sumResult}`}
        </motion.div>
      </section>
    </div>
  );
};

export default FunctionExamplesDemo;